import { post } from '@/utils/request'

/**
 * 淘客会员注册情况
 * 
 * @param {Number} asid 
 * @param {String} page 
 * @param {String} pagesize 
 * @param {String} add_time_from 
 * @param {String} add_time_to 
 * @param {Number} telephone 
 * @param {Number} order_type
 * @param {Number} export2xls
 */
export function admin_rpt_tbk_member_list(data, config) {
  return post('admin_rpt_tbk_member_list', data, config)
}

/**
 * 淘客会员消费状况
 * 
 * @param {Number} asid 
 * @param {String} page 
 * @param {String} pagesize 
 * @param {String} add_time_from 
 * @param {String} add_time_to 
 * @param {Number} telephone 
 * @param {Number} order_type
 * @param {Number} export2xls
 */
export function admin_rpt_tbk_member_consume_list(data, config) {
  return post('admin_rpt_tbk_member_consume_list', data, config)
}

/**
 * 淘客产品列表（全部）
 * 
 */
export function admin_rpk_tbk_product_list(data) {
  return post('admin_rpk_tbk_product_list', data)
}

/* 充值列表 */
export function admin_money_log(data, config) {
  return post('admin_money_log', data, config)
}